<div class="see-through">
  <ng-container *ngIf="!singleRow">
    <div
      class="cam-feed__row cam-feed__row--top"
      *ngIf="!isTelestrating"
      [@snSlideInUp]
      [@snSlideOutUp]
    >
      <div class="cam-feed-row">
        <div
          id="camera-{{ camera.id }}"
          class="not-see-through card-camera"
          [class.active-cam]="this.hoveredCameraId === camera.id"
          *ngFor="let camera of dockedCams.slice(0, 5); trackBy: trackCam"
        >
          <sn-cam-feed-card
            [class.activeCamPair]="hoveredPlaybackId === camera.id"
            [camera]="camera"
            [dragDisabled]="true"
            [unlockDisabled]="playbackCams.includes(camera)"
            [playbackDisabled]="playbackCams.includes(camera)"
            [dragControls]="dragControls"
            [unlockButton]="canUnlock"
            [actions]="actions"
            [allowPlayback]="allowPlayback"
            (unlockCamera)="unlockCam($event)"
            (viewPlayback)="viewPlayback.next($event)"
            (undockCamera)="removeCamera($event)"
            (drawPolyline)="drawPolyline.next($event); hoveredCameraId = $event.camera.id"
            (removePolyline)="removePolyline.next(); hoveredCameraId = null"
          >
          </sn-cam-feed-card>
        </div>
        <div class="cam-feed-row cam-feed-mt-2" *ngIf="playbackCams.length">
          <div
            *ngFor="let camera of playbackCams.slice(0, 5); trackBy: trackCam"
            id="camera-playback-wrapper{{ camera.id }}"
            class="not-see-through card-camera-playback"
          >
            <sn-cam-playback-card
              [@snSlideInUp]
              [@snSlideOutUp]
              [class.activeCamPair]="hoveredPlaybackId === camera.id"
              (mouseenter)="onPlaybackHover(camera, 'enter')"
              (mouseleave)="onPlaybackHover(camera, 'leave')"
              (remove)="removePlayback.next($event)"
              [camera]="camera"
            ></sn-cam-playback-card>
          </div>
        </div>
      </div>
      <div
        class="cam-feed__mid cam-feed__mid--center"
        [ngClass]="{ 'move-top': !barCollapse }"
        *ngIf="!isTelestrating"
        [@snSlideOutUp]
      >
        <sn-cam-feed-card
          [camera]="camera"
          [unlockButton]="false"
          [playback]="false"
          [actions]="actions"
          (lockCamera)="lockCam($event)"
          class="translateCDK card-camera"
          [class.active-cam]="this.hoveredCameraId === camera.id"
          *ngFor="let camera of unlockedCamList"
        >
        </sn-cam-feed-card>
      </div>
      <div
        class="cam-feed__row cam-feed__row--side not-see-through"
        [ngClass]="{ 'move-top': !barCollapse }"
        *ngIf="!isTelestrating"
        [@snSlideInRight]
        [@snSlideOutRight]
      >
        <div
          id="camera-{{ camera.id }}"
          class="card-camera"
          [class.active-cam]="this.hoveredCameraId === camera.id"
          *ngFor="let camera of dockedCams.slice(5); trackBy: trackCam"
        >
          <sn-cam-feed-card
            [dragDisabled]="true"
            [camera]="camera"
            [unlockButton]="true"
            [actions]="actions"
            [playback]="false"
            (unlockCamera)="unlockCam($event)"
            [dragControls]="dragControls"
            [unlockButton]="canUnlock"
            [actions]="actions"
            [allowPlayback]="allowPlayback"
            (unlockCamera)="unlockCam($event)"
            (viewPlayback)="viewPlayback.next($event)"
            (undockCamera)="removeCamera($event)"
            (drawPolyline)="drawPolyline.next($event); hoveredCameraId = $event.camera.id"
            (removePolyline)="removePolyline.next(); hoveredCameraId = null"
          >
          </sn-cam-feed-card>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="singleRow">
    <div
      class="cam-feed__row cam-feed__row--bottom"
      *ngIf="!isTelestrating"
      [@snSlideInDown]
      [@snSlideOutDown]
    >
      <div class="cam-feed-row cam-feed__single-row" (mousewheel)="onRowScroll($event)">
        <div
          id="camera-{{ camera.id }}"
          class="not-see-through card-camera"
          [class.active-cam]="this.hoveredCameraId === camera.id"
          *ngFor="let camera of dockedCams; trackBy: trackCam"
        >
          <sn-cam-feed-card
            [class.activeCamPair]="hoveredPlaybackId === camera.id"
            [camera]="camera"
            [dragDisabled]="true"
            [unlockDisabled]="playbackCams.includes(camera)"
            [playbackDisabled]="playbackCams.includes(camera)"
            [dragControls]="dragControls"
            [unlockButton]="canUnlock"
            [alwaysOn]="alwaysOn"
            [actions]="actions"
            [allowPlayback]="allowPlayback"
            (unlockCamera)="unlockCam($event)"
            (viewPlayback)="viewPlayback.next($event)"
            (undockCamera)="removeCamera($event)"
            (drawPolyline)="drawPolyline.next($event); hoveredCameraId = $event.camera.id"
            (removePolyline)="removePolyline.next(); hoveredCameraId = null"
          >
          </sn-cam-feed-card>
        </div>
      </div>
    </div>
  </ng-container>
</div>
